// extracted by mini-css-extract-plugin
export default {"Sign":"Price_Sign__2xH8O","Price":"Price_Price__EKy3b","Period":"Price_Period__WM4c8"};